import React from "react";
import { MainBody, headers } from "./body";
import { useRightNav } from "../../../utils";
import { ToggleRightNav } from "../../../components/RightNav/ToggleRightNav";

const AreaChart = (props) => {
  const { isMobile } = props;

  const { onBodyScroll, RightNav } = useRightNav(isMobile, headers);

  return (
    <div style={{ display: "flex", justifyContent: "center", width: "100%", marginRight: isMobile ? 0 : 130 }}>
      <MainBody isMobile={isMobile} onBodyScroll={onBodyScroll} />
      {isMobile ? null : <RightNav />}
      {isMobile ? null : <ToggleRightNav />}
    </div>
  );
};

export default AreaChart;
